export default {
    list: {
        title: 'Receivers',
        subtitle: 'Gestisci le tue collaborazioni con i receivers',
        invite: 'Invita Receiver',
        loading: 'Caricamento receivers...',
        searchPlaceholder: 'Cerca per nome o email...',
        statusPlaceholder: 'Filtra per stato',
        countryPlaceholder: 'Filtra per paese',
        description: 'Lista dei receivers con cui collabori',
        headers: {
            company: 'Azienda',
            country: 'Paese',
            email: 'Email',
            status: 'Status',
            activeContainers: 'Container Attivi',
            totalContainers: 'Totale Container',
            lastContainer: 'Ultimo Container',
            inviteDate: 'Data Invito',
            actions: 'Azioni',
        },
        noReceivers: {
            title: 'Nessun receiver trovato',
            message: 'Prova a modificare i filtri di ricerca',
            emptyMessage: 'Inizia invitando il tuo primo receiver',
            inviteFirst: 'Invita Primo Receiver',
        },
        modal: {
            title: 'Invita Receiver',
            selectReceiver: 'Seleziona Receiver',
            selectReceiverPlaceholder: 'Scegli un receiver...',
            notes: 'Note (opzionale)',
            notesPlaceholder: 'Aggiungi una nota per il receiver...',
            selectedReceiver: 'Receiver Selezionato',
            name: 'Nome',
            email: 'Email',
            country: 'Paese',
            cancel: 'Annulla',
            sendInvite: 'Invia Invito',
            mode: {
                email: 'Email Manuale',
                addressBook: 'Address Book',
            },
            emailLabel: 'Indirizzo Email',
            emailPlaceholder: 'Inserisci l\'indirizzo email del receiver',
            emailHint: 'Il receiver verrà aggiunto al sistema quando accetterà l\'invito',
            selectFromAddressBook: 'Seleziona dall\'Address Book',
            selectAddressBookPlaceholder: 'Scegli un contatto dall\'address book...',
            selectedInfo: 'Informazioni Selezionate',
            role: 'Ruolo',
        },
        actions: {
            viewDetails: 'Visualizza Dettagli',
            suspend: 'Sospendi Collaborazione',
            delete: 'Elimina Collaborazione',
        },
        confirmSuspend: 'Sei sicuro di voler sospendere questa collaborazione?',
        confirmDelete: 'Sei sicuro di voler eliminare questa collaborazione?',
        none: 'Nessuno',
        allStatuses: 'Tutti gli stati',
        allCountries: 'Tutti i paesi',
    },
    detail: {
        loading: 'Caricamento dettagli receiver...',
        backToList: 'Torna alla Lista',
        notFound: {
            title: 'Receiver non trovato',
            message: 'Il receiver selezionato non esiste.',
        },
        info: {
            companyInfo: 'Informazioni Azienda',
            containerStats: 'Statistiche Container',
            fields: {
                legalName: 'Ragione Sociale',
                entityType: 'Tipo Entità',
                taxId: 'Partita IVA',
                country: 'Paese',
                address: 'Indirizzo',
                email: 'Email',
                phone: 'Telefono',
                eta: 'ETA',
            },
            stats: {
                total: 'Totale',
                inTransit: 'In Transito',
                delivered: 'Consegnati',
                delayed: 'In Ritardo',
                pendingDocuments: 'Documenti in Attesa',
                highRisk: 'Alto Rischio',
            },
        },
        containers: {
            title: 'Container',
            count: 'di',
            searchPlaceholder: 'Cerca container...',
            statusPlaceholder: 'Filtra per stato',
            riskPlaceholder: 'Filtra per rischio',
            documentsPlaceholder: 'Filtra per documenti',
            headers: {
                containerId: 'ID Container',
                route: 'Percorso',
                progress: 'Progresso',
                eta: 'ETA',
                status: 'Stato',
                docStatus: 'Stato Documenti',
                riskLevel: 'Livello Rischio',
                value: 'Valore',
                actions: 'Azioni',
            },
            noContainers: {
                title: 'Nessun container trovato',
                message: 'Prova a modificare i filtri di ricerca',
                emptyMessage: 'Non ci sono container per questo receiver',
            },
        },
    },
};

